import { NgModule } from '@angular/core';
import { CommonModule, JsonPipe } from '@angular/common';

// import { MatDialogModule, MatFormFieldModule, MatButtonModule, MatInputModule } from '@angular/material';
import { MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { QuickToggleComponent } from './toggle/toggle.component';

// Router
import { AppRoutingModule } from '../../app-routing.module';

// Pipes
import { RfPipe } from '../../pipes/rf/rf.pipe';

// Components
import { HeaderComponent } from './header/header.component';
import { SupportComponent } from './support/support.component';
import { MessagingComponent } from './messaging/messaging.component';

import { ConversationComponent } from './../report/conversation/conversation.component';
import { DropdownComponent } from './ui/dropdown/dropdown.component';
import { LoadingComponent } from './loading/loading.component';
import { ToggleComponent } from './ui/toggle/toggle.component';
import { DialogComponent } from './ui/dialog/dialog.component';
import { TabpageComponent } from './ui/tabs/tabpage/tabpage.component';
import { TabsComponent } from './ui/tabs/tabs.component';
import { AuditComponent } from './audit/audit.component';
import { ScrollingModule, ScrollDispatcher, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AuditItemComponent } from './audit/audit-item/audit-item.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ValueCompareComponent } from './audit/value-compare/value-compare.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { ImporterComponent } from './importer/importer.component';
import { TextSuggestComponent } from './text-suggest/text-suggest.component';
import { SourceSelectComponent } from './source-select/source-select.component';
import { NoteComponent } from './note/note.component';
import { AnimatedBgComponent } from './animated-bg/animated-bg.component';
import { SettingsComponent } from './settings/settings.component';
import { JsonViewerComponent } from './json-viewer/json-viewer.component';


@NgModule({
  declarations: [
    RfPipe,
    HeaderComponent,
    SupportComponent,
    MessagingComponent,
    ConversationComponent,
    DropdownComponent,
    LoadingComponent,
    ToggleComponent,
    DialogComponent,
    TabpageComponent,
    TabsComponent,
    AuditComponent,
    AuditItemComponent,
    ValueCompareComponent,
    QuickToggleComponent,
    ImporterComponent,
    TextSuggestComponent,
    SourceSelectComponent,
    NoteComponent,
    AnimatedBgComponent,
    SettingsComponent,
    JsonViewerComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    ScrollingModule,
    MatTableModule,
    MatTooltipModule,
    ClipboardModule,
  ],
  exports: [
    RfPipe,
    HeaderComponent,
    ConversationComponent,
    DropdownComponent,
    LoadingComponent,
    ToggleComponent,
    TextSuggestComponent,
    SourceSelectComponent,
    TabsComponent,
    TabpageComponent,
    AuditComponent,
    ScrollingModule,
    MatTableModule,
    MatTooltipModule,
    ClipboardModule,
    QuickToggleComponent,
    SupportComponent,
    ImporterComponent,
    NoteComponent,
    AnimatedBgComponent,
    SettingsComponent
  ],
  providers: [
    {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {disableClose: true, hasBackdrop: true}},
    RfPipe,
    JsonPipe
  ]
})
export class SharedModule { }